import type { WizardStep } from "./wizard-state";

const STEPS: { key: WizardStep; label: string }[] = [
  { key: "species", label: "Lineage" },
  { key: "character", label: "Character" },
  { key: "background", label: "Origin" },
  { key: "graph", label: "Choices" },
  { key: "review", label: "Review" },
  { key: "scenario", label: "Scenario" },
  { key: "loading", label: "Go" },
];

export function WizardStepper({
  currentStep,
  steps = STEPS,
}: {
  currentStep: WizardStep;
  steps?: readonly { key: WizardStep; label: string }[];
}) {
  const currentIndex = Math.max(
    0,
    steps.findIndex((s) => s.key === currentStep)
  );
  const current = steps[currentIndex] ?? steps[0];

  return (
    <div className="border-b bg-background px-4 py-3">
      <div className="mx-auto flex w-full max-w-3xl flex-col gap-2">
        <div className="flex items-center justify-between gap-3 sm:hidden">
          <span className="text-muted-foreground text-xs">
            Step {currentIndex + 1} of {steps.length}
          </span>
          <span className="font-medium text-sm">{current.label}</span>
        </div>

        <div className="flex items-center gap-1 sm:gap-2">
          {steps.map((step, i) => (
            <div
              className="flex min-w-0 flex-1 items-center gap-1"
              key={step.key}
            >
              {i > 0 && (
                <div
                  className={`h-0.5 min-w-3 flex-1 ${
                    i <= currentIndex ? "bg-primary" : "bg-muted"
                  }`}
                />
              )}
              <div
                className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full font-bold text-xs ${
                  i <= currentIndex
                    ? "bg-primary text-primary-foreground"
                    : "bg-muted text-muted-foreground"
                }`}
                title={step.label}
              >
                {i + 1}
              </div>
              <span
                className={`hidden truncate text-xs sm:inline ${
                  i <= currentIndex ? "text-primary" : "text-muted-foreground"
                }`}
              >
                {step.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
